import { useProducts } from "@/hooks/useCatalogue";
import PageIntro from "@/components/PageIntro";
import Reveal from "@/components/Reveal";
import ProductCard from "@/components/ProductCard";

export default function Products() {
  const { data: products = [], isLoading } = useProducts();
  return (
    <div>
      <PageIntro
        eyebrow="Our Rituals"
        title="Three products, made with intention"
        description="We launch with exactly three: Serum, Sunscreen and Facewash. Each has a dedicated page. This collection order is not a recommended application order."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        {isLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {[1, 2, 3].map((i) => (
              <div key={i} className="aspect-square bg-linen animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {products.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.12}>
                <ProductCard product={p} index={i} />
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
